export const getInitialFormValues = (basis) => {
    return {
        description: basis?.description ?? '',
        commodityId: null,
        priceFormulaId: null,
        onPeakPeriodId: null,
        offPeakPeriodId: null,
        atcPeriodId: null,
        basicModelId: null,
        basisModelTypeId: null,
        moduleProcessId: null,
        modelWeightId: null,
        transformMethodId: null,
        refForwardOnPeakId: null,
        refForwardOffPeakId: null,
        refForwardATCId: null,
        delForwardOnPeakId: null,
        delForwardOffPeakId: null,
        delForwardATCId: null,
        refSpotPriceId: null,
        delSpotPriceId: null,
        scalingintervalId: null,
        daHourlyBasisId: null,
        hourlySim: false,
        dailySim: false,
        forwardSim: false,
        lmpFlag: false,
        ...basis,
    };
};

export const validateDescription = (value, intl) => {
    const trimmed = value.trim();
    const label = intl.formatMessage({ id: 'basis_name' });

    if (trimmed.length === 0) {
        return intl.formatMessage({ id: 'common_forms_validation_required' }, { label });
    }

    if (trimmed.length > 150) {
        return intl.formatMessage(
            { id: 'common_forms_validation_length' },
            { label, lengthRule: '150 characters or less' }
        );
    }
};
